module.exports = __webpack_public_path__ + "img/kiwoom_main_left2.f98aa11e.png";